import React, { Component } from 'react';

import axios from 'axios';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './GMC.css';

import { FilterView,BannerShimmer, SetTournGameModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView, LoadingState } from '.././components/Common';
import { GMCCoreHeader, GMCCoreTeam, GMCCoreFeed, Fixture, GmcFixture, AddPlayersForm, Stand, GameTeamsForm, GameVenueSportForm, GameDateTimeForm, GameAdminHalfForm, } from '.././components/GMC';

import LineupLimit, {availableSports} from '../components/SportLineLimit';
import Redirect from 'react-router-dom/Redirect';

let mainStore = {
  game: {},
  gmcGame: {},
  games: [],
  results: [],
  activeCreateStep: 1,
  errors: {},
  getResults: function () {
    return this.results
  },
  setResults: function (res) {
    this.results = res
  },
  getGMCGame: function () {
    return this.gmcGame
  },
  setGMCGame: function (gmcGame) {
    this.gmcGame = gmcGame
    return this
  },
  getGame: function () {
    return this.game
  },
  setGame: function (game) {
    this.game = game
    return this
  },
  getGames: function () {
    return this.games
  },
  setGames: function (games) {
    this.games = games
    return this
  },
  getErrors: function () {
    return this.game
  },
  setErrors: function (errors) {
    this.errors = errors
    return this
  },
  getCreateStep: function () {
    return this.activeCreateStep
  },
  setCreateStep: function (activeCreateStep) {
    this.activeCreateStep = activeCreateStep
    return this
  }
}

let GMCTags = {
  Soccer: {
    player: ["Goal", "Shot On Target", "Blocked Shot", "Corner", "Foul", "Offside", "YC", "RC", "Assist", "Passing Success", "Tackles"],
    team: ["Tackle Success", "Territorial Advantage"]
  }
}

export class GMCView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: { id: null },
      activeTab: 'createGame',
      tabs: [
        { val: "createGame", key: "Create Game" },
        { val: "leagueTable", key: "Tournaments" },
        { val: "gameFixtures", key: "Fixtures" },
        { val: "gameResults", key: "Results" },
        //{val:"playOff",key:"Play-offs"},
        { val: "gmcList", key: "GMC" },
      ],
      isLoadingRes: true,
      isLoadingFix: true,
      isLoadingTourns: true,
      isLoadingGMC: true,
    }
    this.setTab = this.setTab.bind(this)
  }

  componentDidMount() {
    FakeData.mountState("gmc_view", true);
    const _that = this;
    _that.getUserData()
    _that.getGames()
    _that.getStandings()
    _that.getResults()
  }

  refresh = () => {
    const _that = this;
    _that.getUserData()
    _that.getGames()
    _that.getStandings()
    _that.getResults()
  }

  componentWillUnmount() {
    clearInterval(this.getUserDataID)
    FakeData.mountState("gmc_view", false);
  }

  getGames() {
    const _that = this

    const dataTo = {
      userId: FakeData.getData("yoo").id,
      leagues: FakeData.listify(FakeData.getData("leagueIds")),
      teams: FakeData.listify(FakeData.getData("teamIds"))
    }

    FakeData.post("/getGames.php?auth0", dataTo, {
      success: ((res) => {
        //console.log(res)
        if (!FakeData.isMounted("gmc_view")) {
          return;
        }
        mainStore.setGames(res)
        _that.setState({ isLoadingFix:false });
        FakeData.setData("gmc_games", res)
        setTimeout(() => {
          //_that.getGames()
        }, 1000)
      }),
      error: ((err) => {
        //console.log(err)
      })
    })
  }

  getStandings() {
    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo")
    }

    FakeData.post("/getLeaguesManaged.php?auth0", dataTo, {
      success: ((res) => {
        if (!FakeData.isMounted("gmc_view")) {
          return;
        }
        FakeData.setData("stands", res)
        _that.setState({ isLoadingTourns:false });
        setTimeout((() => {
          //_that.getStandings()
        }), 1000)
      }),
      error: ((err) => {

      })
    })
  }

  getResults() {
    const _that = this
    const dataTo = {
      userId: FakeData.getData("yoo").id,
      leagues: FakeData.listify(FakeData.getData("leagueIds")),
      teams: FakeData.listify(FakeData.getData("teamIds"))
    }

    FakeData.post("/getGamesResults.php?auth0",
      dataTo,
      {
        success: ((res) => {
          if (!FakeData.isMounted("gmc_view")) {
            return;
          }
          mainStore.setResults(res)
          FakeData.setData("gmc_results", res)
          _that.setState({ isLoadingRes:false });
          setTimeout(() => {
            //_that.getResults()
          }, 1500)
        }),
        error: ((err) => {
          //console.log(err);
          setTimeout(() => {
            //_that.getResults()
          }, 1500)
        })
      }
    )
  }

  setTab(item) {
    this.setState({
      activeTab: item.val
    })
  }

  getUserData() {
    if (!FakeData.isMounted("gmc_view")) {

      return;
    }
    const _that = this
    this.setState({ user: FakeData.getData("yoo") });
    setTimeout(() => {
      _that.getUserData()
    }, 1000)
  }

  saveGame() {
    this.setState({ activeTab: "gameFixtures" });
  }

  render() {
    const allTeams = FakeData.getData("all_teams");
    const { user, isLoadingFix, isLoadingGMC, isLoadingRes, isLoadingTourns } = this.state;
    if (user.id === null) {
      return (
        <BannerShimmer />
      );
    }
    return (
      <div className="gmc_container">
        <Helmet
          title={"GMC - Supotsu"}
          meta={[
            { "name": "description", "content": "Description of page" },
            { property: "og:type", content: "GMC.Supotsu" },
            { property: "og:title", content: "GMC - Supotsu" },
            { property: "og:image", content: "" },
            { property: "og:url", content: FakeData.baseURL + "/#" + this.props.location.pathname + this.props.location.search }
          ]}
        />
        <div className="tabs row main_content sp-gmc-flex-width">
          <TabLabels activeTab={this.state.activeTab} onTabSelect={this.setTab} tabs={this.state.tabs} />
          <TabViews onRefreshData={this.refresh} isLoadingRes={isLoadingRes} isLoadingTourns={isLoadingTourns} isLoadingFix={isLoadingFix} onSaveGame={this.saveGame.bind(this)} teams={allTeams} user={user} activeTab={this.state.activeTab} />
        </div>
      </div>
    );
  }
}

class TabLabels extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const items = this.props.tabs;

    return (
      <div className="labels">
        {items.map((item) =>
          <div key={item.val} onClick={() => this.props.onTabSelect(item)} className={(this.props.activeTab === item.val) ? 'label active' : 'label'}>{item.key}</div>
        )}
      </div>
    );
  }
}

class TabViews extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const allTeams = this.props.teams
    return (
      <div className="views">
        {(this.props.activeTab === "createGame") ? (<CreateGame onRefreshData={this.props.onRefreshData} onSaveGame={this.props.onSaveGame} user={this.props.user} teams={allTeams} uniq={this.props.activeTab} />) :
          (this.props.activeTab === "leagueTable") ? (<StandingsList onRefreshData={this.props.onRefreshData} isLoading={this.props.isLoadingTourns} user={this.props.user} teams={allTeams} uniq={this.props.activeTab} />) :
            (this.props.activeTab === "gameResults") ? (<ResultsList onRefreshData={this.props.onRefreshData} isLoading={this.props.isLoadingRes} user={this.props.user} teams={allTeams} uniq={this.props.activeTab} />) :
              (this.props.activeTab === "gameFixtures") ? (<FixturesList onRefreshData={this.props.onRefreshData} isLoading={this.props.isLoadingFix} user={this.props.user} teams={allTeams} user={this.props.user} uniq={this.props.activeTab} />) :
                (this.props.activeTab === "playOff") ? (<PlayOffsList onRefreshData={this.props.onRefreshData} user={this.props.user} teams={allTeams} uniq={this.props.activeTab} />) :
                  (<GMCList onRefreshData={this.props.onRefreshData} isLoading={this.props.isLoadingFix} user={this.props.user} teams={allTeams} uniq={this.props.activeTab} />)}
      </div>
    );
  }
}

class GMCList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      games: (FakeData.getData("gmc_games")) ? FakeData.getData("gmc_games") : [],
      sport: "",
      filter: ""
    }
  }

  componentDidMount() {
    FakeData.mountState("list_gmc", true)
    if (this.state.games.length > 0) {
      return
    }

    this.dataID = setInterval(() => this.getData(), 1000)
  }

  componentWillUnmount() {
    FakeData.mountState("list_gmc", true)
    clearInterval(this.dataID)
  }

  getData() {
    if (FakeData.isMounted("list_gmc")) {
      this.setState({
        games: (FakeData.getData("gmc_games")) ? FakeData.getData("gmc_games") : []
      });
    }
  }

  selectFilter(item) {
    this.setState({
      filter: item
    });
  }

  selectSport(item) {
    this.setState({
      sport: (this.state.sport === item) ? "" : item
    });
  }

  filter(sport, key) {
    const arr = []
    const finArr = []
    const val = key

    this.state.games.forEach((item, i) => {
      if (item.game.matchType.toLowerCase().indexOf(key.toLowerCase()) > -1) {
        arr.push(item)
      }
    })

    arr.forEach((item, i) => {
      if (item.game.sport.toLowerCase().indexOf(sport.toLowerCase()) > -1) {
        finArr.push(item)
      }
    })
    return finArr
  }

  render() {
    const items = this.filter(this.state.sport, this.state.filter)
    const data = ["League", "Knockout", "Groups", "Friendly"]
    if(this.props.isLoading){
      return(
        <LoadingState isShown={true} text={"Please wait.."}/>
      )
    }
    return (
      <div className="view">
        {this.state.games.length > 0 &&
          <FilterView data={data} onSelectedFilter={(item) => this.selectFilter(item)} onSelectSport={(item) => this.selectSport(item)} />
        }
        {items.length > 0 &&
          <div className="fixture-list">
            {
              items.map((fixture, i) =>
                <GmcFixture key={fixture.game.id} game={fixture.game} class={(i % 2 === 0) ? 'odd' : 'even'} results={fixture.results} />
              )
            }
          </div>
        }

        {items.length === 0 &&
          <div className="empty">
            <span className="big">No Fixture Found</span>
          </div>
        }
      </div>
    );
  }
}

class PlayOffsList extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="view">
        <PlayOffView />
      </div>
    );
  }
}

class ResultsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      results: (FakeData.getData("gmc_results")) ? FakeData.getData("gmc_results") : [],
      sport: "",
      filter: ""
    }
  }

  componentDidMount() {
    this.setState({ results: (FakeData.getData("gmc_results")) ? FakeData.getData("gmc_results") : [] });
  }

  selectFilter(item) {
    this.setState({
      filter: item
    });
  }

  selectSport(item) {
    this.setState({
      sport: (this.state.sport === item) ? "" : item
    });
  }

  filter(sport, key) {
    const arr = []
    const finArr = []
    const val = key

    this.state.results.forEach((item, i) => {
      if (item.type.toLowerCase().indexOf(key.toLowerCase()) > -1) {
        arr.push(item)
      }
    })

    arr.forEach((item, i) => {
      if (item.sport.toLowerCase().indexOf(sport.toLowerCase()) > -1) {
        finArr.push(item)
      }
    })
    return finArr
  }

  render() {
    const items = this.filter(this.state.sport, this.state.filter)
    const data = ["League", "Knockout", "Groups", "Friendly"]
    if(this.props.isLoading){
      return(
        <LoadingState isShown={true} text={"Please wait.."}/>
      )
    }
    return (
      <div className="view">
        {this.state.results.length > 0 &&
          <FilterView data={data} onSelectedFilter={(item) => this.selectFilter(item)} onSelectSport={(item) => this.selectSport(item)} />
        }
        {items.length > 0 &&
          <ul className="gmc_list">
            {
              items.map((item, i) =>
                <li key={i}>
                  <div className="gmc_result_holder">
                    <div className="gmc_results_team_one">{item.teamOne.name}</div>
                    <div className="gmc_results_score">{item.results.teamOneGoals}-{item.results.teamTwoGoals}</div>
                    <div className="gmc_results_team_two">{item.teamTwo.name}</div>
                  </div>
                </li>
              )
            }
          </ul>
        }

        {items.length === 0 &&
          <div className="empty">
            <span className="big">No Results Found</span>
          </div>
        }
      </div>
    );
  }
}

class FixturesList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      games: (FakeData.getData("gmc_games")) ? FakeData.getData("gmc_games") : [],
      sport: "",
      filter: ""
    }

    this.time = 0;
  }

  componentDidMount() {
    FakeData.mountState("fix_gmc", true)
    this.getGames()
  }

  componentWillUnmount() {
    FakeData.mountState("fix_gmc", false)
  }

  getGames() {
    const _that = this
    if (!FakeData.isMounted("fix_gmc")) {
      return;
    }

    _that.setState({
      games: (FakeData.getData("gmc_games")) ? FakeData.getData("gmc_games") : []
    })

    setTimeout((() => {
      _that.getGames()
    }), 1000)
  }

  selectFilter(item) {
    this.setState({
      filter: item
    });
  }

  selectSport(item) {
    this.setState({
      sport: (this.state.sport === item) ? "" : item
    });
  }

  filter(sport, key) {
    const arr = []
    const finArr = []
    const val = key

    this.state.games.forEach((item, i) => {
      if (item.game.matchType.toLowerCase().indexOf(key.toLowerCase()) > -1) {
        arr.push(item)
      }
    })

    arr.forEach((item, i) => {
      if (item.game.sport.toLowerCase().indexOf(sport.toLowerCase()) > -1) {
        finArr.push(item)
      }
    })
    return finArr
  }

  render() {
    const items = this.filter(this.state.sport, this.state.filter)
    const data = ["League", "Knockout", "Groups", "Friendly"]
    const allTeams = this.props.teams
    if(this.props.isLoading){
      return(
        <LoadingState isShown={true} text={"Please wait.."}/>
      )
    }
    return (
      <div className="view">
        {this.state.games.filter((item,i)=>{
          const matchDate = new Date(item.fullDate);
          const today = new Date();
          const isReady = matchDate.setHours(0,0,0,0) === today.setHours(0,0,0,0)?true:false;
          return !isReady;
        }).length > 0 &&
          <FilterView data={data} onSelectedFilter={(item) => this.selectFilter(item)} onSelectSport={(item) => this.selectSport(item)} />
        }
        {items.length > 0 &&
          <div className="fixture-list">
            {
              items.map((fixture, i) =>
                <Fixture onRefreshData={this.props.onRefreshData} key={fixture.game.id} teams={allTeams} user={this.props.user} game={fixture.game} class={(i % 2 === 0) ? 'odd' : 'even'} results={fixture.results} />
              )
            }
          </div>
        }

        {items.length === 0 &&
          <div className="empty">
            <span className="big">No Fixture Found</span>
          </div>
        }
      </div>
    );
  }
}

class StandingsList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stands: (FakeData.getData("stands")) ? FakeData.getData("stands") : [],
      sport: "",
      filter: ""
    }
  }

  componentDidMount() {
    FakeData.mountState("standings_gmc", true);
    this.getStandings()
  }

  componentWillUnmount() {
    FakeData.mountState("standings_gmc", false);
  }

  getStandings() {
    const _that = this
    if (!FakeData.isMounted("standings_gmc")) {
      return;
    }
    _that.setState({
      stands: (FakeData.getData("stands")) ? FakeData.getData("stands") : [],
    });
    setTimeout((() => {
      _that.getStandings()
    }), 1000)
  }

  selectFilter(item) {
    this.setState({
      filter: item
    });
  }

  selectSport(item) {
    this.setState({
      sport: (this.state.sport === item) ? "" : item
    });
  }

  filter(sport, key) {
    const arr = []
    const val = (key === "league") ? "League" : (key === "group_knockout") ? "Groups And Knockout" : "Knockout"

    this.state.stands.forEach((item, i) => {
      if (key === "") {
        if ((item.sport === sport)) {
          arr.push(item)
        } else {
          arr.push(item)
        }
      } else if (sport === "") {
        if ((item.category === val)) {
          arr.push(item)
        } else {
          arr.push(item)
        }
      } else if ((item.category === val)) {
        arr.push(item)
      } else if ((item.sport === sport)) {
        arr.push(item)
      }
    })
    return arr
  }

  render() {
    const data = ["league", "group_knockout"]
    const stands = this.filter(this.state.sport, this.state.filter)
    if(this.props.isLoading){
      return(
        <LoadingState isShown={true} text={"Please wait.."}/>
      )
    }
    return (
      <div className="view">
        {this.state.stands.length > 0 &&
          <FilterView data={data} onSelectedFilter={(item) => this.selectFilter(item)} onSelectSport={(item) => this.selectSport(item)} />
        }
        {stands.length > 0 &&
          <div className="stands">
            {
              stands.map((stand, i) => {
                if (stand.groups.length === 0) {
                  return null;
                } else {
                  return (<Stand onRefreshData={this.props.onRefreshData} user={this.props.user} key={i} class={(i % 2 !== 0) ? "odd" : ""} stand={stand} />)
                }
              }
              )
            }
          </div>
        }

        {this.state.stands.length === 0 &&
          <div className="empty">
            <span className="big">No Results Found</span>
          </div>
        }
      </div>
    );
  }
}

class CreateGame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      game: mainStore.getGame(),
      errors: mainStore.getErrors(),
      name: "ali",
      token: Date.now(),
      teams: this.props.teams,
      myTeams: FakeData.getData("all_teams"),
      count: 0,
      activeTab: mainStore.getCreateStep(),
      rand: 0,
      navData: [
        { key: 1, val: "Step 1: Create Game" },
        { key: 2, val: "Step 2: Add Players" }
      ]
    }

    this.selectTeamOne = this.selectTeamOne.bind(this)
    this.selectTeamTwo = this.selectTeamTwo.bind(this)
    this.selectMatchType = this.selectMatchType.bind(this)
    this.selectMatchPlace = this.selectMatchPlace.bind(this)
    this.selectMatchDate = this.selectMatchDate.bind(this)
    this.selectMatchTime = this.selectMatchTime.bind(this)
    this.selectHalfTime = this.selectHalfTime.bind(this)
    this.selectExtraTime = this.selectExtraTime.bind(this)
    this.selectAdmin = this.selectAdmin.bind(this)
    this.selectLeague = this.selectLeague.bind(this)
    this.selectSport = this.selectSport.bind(this)
    this.setTab = this.setTab.bind(this)
    this.setYourTeam = this.setYourTeam.bind(this)
    this.setLineup = this.setLineup.bind(this)
    this.setNewPlayer = this.setNewPlayer.bind(this)
    this.saveLineup = this.saveLineup.bind(this)
  }

  setLineup(team) {
    const isHomeTeam = (this.state.game.teamOne.id === team.id) ? true : false
    if (isHomeTeam) {
      this.state.game.teamOne = team
      this.setState({
        game: this.state.game
      });
    } else {
      this.state.game.teamTwo = team
      this.setState({
        game: this.state.game
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  setNewPlayer(player) {
    this.state.game.homeTeam.players.push(player)
    this.setState({
      game: this.state.game
    });
    this.setLineup(this.state.game.homeTeam)
  }

  selectTeamOne(team) {
    if (this.state.game['teamTwo'] === team) {
      this.state.errors['teamOneError'] = true
      this.setState({
        errors: this.state.errors,
        game: this.state.game
      });
    } else {
      this.state.errors['teamOneError'] = false
      this.state.game['teamOne'] = team
      this.setState({
        errors: this.state.errors,
        game: this.state.game
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectTeamTwo(team) {
    if (this.state.game['teamOne'] === team) {
      this.state.errors['teamTwoError'] = true
      this.setState({
        errors: this.state.errors,
        game: this.state.game
      });
    } else {
      this.state.errors['teamTwoError'] = false
      this.state.game['teamTwo'] = team
      this.setState({
        errors: this.state.errors,
        game: this.state.game
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectMatchType(type) {
    this.state.game['matchType'] = type
    const bool = (type !== "Friendly") ? true : false
    const isLeague = (type === "League") ? true : false
    this.state.game['isTouenament'] = bool
    this.state.game['isLeague'] = isLeague
    this.setState({
      game: this.state.game
    });

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectMatchPlace(place) {
    if ((place.length <= 0) || (place === " ")) {
      this.state.errors['matchError'] = true
      this.setState({
        errors: this.state.errors
      });
    } else {
      this.state.game['matchPlace'] = place
      this.state.errors['matchError'] = false
      this.setState({
        game: this.state.game,
        errors: this.state.errors
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectHalfTime(time) {
    if (time <= 0) {
      this.state.errors['halfTimeError'] = true
      this.setState({
        errors: this.state.errors
      });
    } else {
      this.state.game['matchHalf'] = time
      this.state.errors['halfTimeError'] = false
      this.setState({
        game: this.state.game,
        errors: this.state.errors
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectExtraTime(time) {
    if (time <= 0) {
      this.state.errors['extraTimeError'] = true
      this.setState({
        errors: this.state.errors
      });
    } else {
      this.state.game['matchExtra'] = time
      this.state.errors['extraTimeError'] = false
      this.setState({
        game: this.state.game,
        errors: this.state.errors
      });
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectMatchDate(date) {
    this.state.game['matchDate'] = date
    this.setState({
      game: this.state.game
    });

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectMatchTime(time) {
    this.state.game['matchTime'] = time
    this.setState({
      game: this.state.game
    });

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectAdmin(admin) {
    this.state.game['matchAdmin'] = admin
    this.setState({
      game: this.state.game
    });

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectLeague(tournament) {
    this.state.game['tournament'] = tournament
    this.setState({
      game: this.state.game
    });

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  selectSport(sport) {
    this.state.game['sport'] = sport
    const { lineup, subs } = LineupLimit[sport.name.toLowerCase()];
    this.state.game['lineup'] = lineup;
    this.state.game['subs'] = subs;

    this.setState({
      game: this.state.game
    });

    switch (sport.name) {
      case "Soccer":
        this.setMaxNoOfPlayers(11, 5)
        break;
      case "Rugby":
        this.setMaxNoOfPlayers(15, 5)
        break;
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  setMaxNoOfPlayers(lineup, subs) {
    this.state.game['maxLineup'] = lineup
    this.state.game['maxSubs'] = subs

    this.setState({
      game: this.state.game
    })

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  saveGame() {
    if (!this.state.game.teamOne) {
      this.state.errors['teamOneError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['teamOneError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    if (!this.state.game.teamTwo) {
      this.state.errors['teamTwoError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['teamTwoError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    if ((this.state.game.matchType === null) || (this.state.game.matchType === "")) {
      this.state.game.matchType = "Friendly"
      this.setState({
        game: this.state.game
      })
    }

    if ((this.state.game.matchPlace === null) || (this.state.game.matchPlace === "")) {
      this.state.errors['matchError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['matchError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    if (!this.state.game.sport) {
      this.state.errors['sportError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['sportError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    /*if(!this.state.game.tournament){
      this.state.errors['tournamentError'] = true
      this.setState({
        errors:this.state.errors
      })
      return
    } else {
      this.state.errors['tournamentError'] = false
      this.setState({
        errors:this.state.errors
      })
    }*/

    /*if((this.state.game.matchExtra==null)||(this.state.game.matchExtra=="")){
      this.state.errors['extraTimeError'] = true
      this.setState({
        errors:this.state.errors
      })
      return
    } else {
      this.state.errors['extraTimeError'] = false
      this.setState({
        errors:this.state.errors
      })
    }*/

    if ((this.state.game.matchDate === null) || (this.state.game.matchDate === "")) {
      this.state.errors['dateError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['dateError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    if ((this.state.game.matchTime === null) || (this.state.game.matchTime === "")) {
      this.state.errors['timeError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['timeError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    if ((this.state.game.matchHalf === null) || (this.state.game.matchHalf === "")) {
      this.state.errors['halfTimeError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['halfTimeError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    const date = new Date(this.state.game.matchDate+" "+this.state.game.matchTime+":00");
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    this.state.game['fullTimestamp'] = date.toUTCString()

    if (!this.state.game.matchAdmin) {
      this.state.errors['matchAdminError'] = true
      this.setState({
        errors: this.state.errors
      })
      return
    } else {
      this.state.errors['matchAdminError'] = false
      this.setState({
        errors: this.state.errors
      })
    }

    const _that = this

    //console.log(this.state.game);

    FakeData.post("/createGame.php?auth0", this.state.game, {
      success: ((data) => {
        _that.state.game.id = data.id
        _that.state.game.duration = data.duration
        _that.setState({
          isSetGame: true,
          game: _that.state.game
        });
        const tab = { key: 2, val: "Step 2: Add Players" }
        _that.setTab(tab)
        mainStore.setErrors(_that.state.errors)
        mainStore.setGame(_that.state.game)
      }),
      error: ((err) => {
        _that.setState({
          isGameCreateError: true
        });
      })
    },true, "", ()=>{})
  }

  saveLineup() {
    if ((this.state.game.homeTeam.lineup.length < this.state.game.lineup) || (this.state.game.homeTeam.subs.length < this.state.game.subs)) {
      FakeData.alert("The number of players in your lineup should be " + this.state.game.lineup + ", and " + this.state.game.subs + " players in your substitute list!");
      this.state.game['gamePlayerError'] = true
      this.setState({
        game: this.state.game
      })
      return
    } else {
      this.state.game['gamePlayerError'] = false
      this.setState({
        game: this.state.game
      })
    }

    const _that = this
    const dataTo = {
      gameId: this.state.game.id,
      teamId: this.state.game.homeTeam.id,
      squadId: this.state.game.homeTeam.squadId,
      adminId: this.state.game.matchAdmin.id,
      lineup: this.state.game.homeTeam.lineup,
      subs: this.state.game.homeTeam.subs,
      starttime: 0,
      endTime: this.state.game.duration
    }

    FakeData.post('/saveGamePlayers.php?auth0', dataTo, {
      success: ((data) => {
        if (data) {
          const tab = { key: 1, val: "Step 1: Create Game" }

          _that.setTab(tab)

          setTimeout(() => {
            mainStore.setGame({})
            _that.setState({
              game: {},
              token: Date.now(),
              isGameError: false,
              isGameCreateError: false
            });
            this.props.onSaveGame()
          }, 1500)
        }
      }),
      error: ((err) => {

      })
    }, true, "", (e) => { })

    mainStore.setErrors({})
  }

  setYourTeam(num, bool, count) {
    const team = (num === 0) ? this.state.game.teamOne : this.state.game.teamTwo
    let countFor = count + 1
    if (bool) {
      this.state.game["homeTeam"] = team
      this.setState({
        game: this.state.game
      });
    } else {
      if (countFor > 1) {
        if (num === 0) {
          delete this.state.game['teamOne']
          this.state.errors['teamOneError'] = true
          this.state.errors['teamtwoError'] = false
          this.setState({
            errors: this.state.errors,
            game: this.state.game,
            count: 0,
            rand: 0
          })
        } else {
          delete this.state.game['teamTwo']
          this.state.errors['teamtwoError'] = true
          this.state.errors['teamOneError'] = false
          this.setState({
            errors: this.state.errors,
            game: this.state.game,
            count: 0,
            rand: 1
          })
        }
      } else {
        this.setState({
          rand: num,
          count: countFor
        })
      }
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  setTab(tab) {
    if ((!this.state.game.id) && (tab.key === 2)) {
      this.setState({
        isGameError: true
      });
      return
    }

    this.setState({
      activeTab: tab.key
    });

    mainStore.setCreateStep(tab.key)
  }

  rand(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  onSave(players, lineup, subs, callback) {
    const isHomeTeam = (this.state.game.homeTeam.id === this.state.game.teamOne.id) ? true : false
    if (isHomeTeam) {
      this.state.game.teamOne.lineup = lineup;
      this.state.game.teamOne.subs = subs;
      this.state.game.teamOne.players = players;

      this.state.game.homeTeam.lineup = lineup;
      this.state.game.homeTeam.subs = subs;
      this.state.game.homeTeam.players = players;
      this.setState({
        game: this.state.game
      });

      callback.call(this)
    } else {
      this.state.game.teamTwo.lineup = lineup;
      this.state.game.teamTwo.subs = subs;
      this.state.game.teamTwo.players = players;

      this.state.game.homeTeam.lineup = lineup;
      this.state.game.homeTeam.subs = subs;
      this.state.game.homeTeam.players = players;
      this.setState({
        game: this.state.game
      });

      callback.call(this)
    }

    mainStore.setErrors(this.state.errors)
    mainStore.setGame(this.state.game)
  }

  render() {
    const rand = (this.state.rand === 0) ? 1 : 0
    const team = (rand === 0) ? this.state.game.teamOne : this.state.game.teamTwo
    const allTeams = this.props.teams
    const User = FakeData.getData("yoo")
    if (User.id === null) {
      return null
    }

    if (this.state.activeTab === 2) {
      return (
        <div className="view">
          <GameBreadCrumb key={this.state.token + "adg"} gameError={this.state.isGameError} gameCreateError={this.state.isGameCreateError} active={this.state.activeTab} data={this.state.navData} onCrumbChange={this.setTab} />
          <AddPlayersForm key={this.state.token + "adp"} onSave={this.onSave.bind(this)} onLineupChange={this.setLineup} onNewPlayerAdded={this.setNewPlayer} user={this.props.user} game={this.state.game} />
          {(((this.state.game.homeTeam.lineup.length > 0 && this.state.game.homeTeam.lineup.length !== this.state.game.maxLineup)
            || (this.state.game.homeTeam.subs.length > 0 && this.state.game.homeTeam.subs.length !== this.state.game.maxSubs))
            || this.state.game.gamePlayerError) &&
            <div className="gameError">
              <span>Number of starting players should be equal to {this.state.game.lineup}, add {this.state.game.lineup - this.state.game.homeTeam.lineup.length} more</span>
              <span>Number of substitute players should be equal to {this.state.game.subs}, add {this.state.game.subs - this.state.game.homeTeam.subs.length} more</span>
            </div>
          }
          {
            <button className="add-game-save" onClick={this.saveLineup.bind(this)}>Save</button>
          }
        </div>
      )
    }

    const sports = FakeData.listify(FakeData.getData("all_sports")).filter((sport, i)=>{
      return FakeData.inArray(sport.name.toLowerCase(), availableSports)
    })
    return (
      <div className="view">
        <GameBreadCrumb key={this.state.token + "agg"} gameError={this.state.isGameError} gameCreateError={this.state.isGameCreateError} active={this.state.activeTab} data={this.state.navData} onCrumbChange={this.setTab} />
        {((this.state.game.teamOne) && (this.state.game.teamTwo) && (!this.state.game.homeTeam)) &&
          <h1 className="is-your-team">Is {team.name} your team? <button onClick={() => this.setYourTeam(rand, true, this.state.count)}>Yes</button><button onClick={() => this.setYourTeam(rand, false, this.state.count)}>No</button></h1>
        }
        {this.state.game.sport && <GameTeamsForm key={this.state.token + "gtf"} user={User} pickerData={User.friends} game={this.state.game} errors={this.state.errors} onTeamOneSelected={this.selectTeamOne} onTeamTwoSelected={this.selectTeamTwo} data={allTeams.filter((_team, _index)=>{
          return _team.sport.toLowerCase().indexOf(this.state.game.sport.name.toLowerCase()) > -1;
        })} />}
        <GameVenueSportForm key={this.state.token + "gvsf"} isSportDisabed={Boolean(this.state.game.sport)} user={User} sports={sports} places={User.placesLived.others} game={this.state.game} errors={this.state.errors} onSportSelect={this.selectSport} onSetPlace={this.selectMatchPlace} />
        <GameDateTimeForm key={this.state.token + "gdtfadp"} user={User} game={this.state.game} onSetTime={this.selectMatchTime} onSetDate={this.selectMatchDate} errors={this.state.errors} errors={this.state.errors} />
        <GameAdminHalfForm key={this.state.token + "ddd"} user={User} game={this.state.game} onSetHalf={this.selectHalfTime} onPersonSelected={this.selectAdmin} errors={this.state.errors} data={User.friends} />
        <button className="add-game-save" onClick={this.saveGame.bind(this)}>Save</button>
      </div>
    );
  }
}

class GameBreadCrumb extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: this.props.data
    }
  }

  render() {
    const items = this.state.data
    return (
      <div className="gmc-bread-crumb">
        {items.map((item) =>
          <div key={item.key} onClick={() => this.props.onCrumbChange(item)} className={(this.props.active === item.key) ? 'gmc-bread-crumb-item active' : 'gmc-bread-crumb-item'}>{item.val}</div>
        )}
      </div>
    );
  }
}
const {EventSource} = window
export class GMCCore extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      user: { id: null },
      isLoading: true,
      game: mainStore.getGMCGame(),
      error: false,
      errMsg: "",
      currentTime: mainStore.getGMCGame().currentTime,
      extraTime: mainStore.getGMCGame().matchExtra,
      selectionState: {
        isSelectingPlayer: false,
        isSelectingTeam: false
      },
      selectedTeam: {},
      selectedPlayer: {},
      selectedTag: "",
      secondPlayer: {},
      selectedTeamFor: "",
      value: "",
      comment: "",
      user: FakeData.getData("yoo")
    }

    this.startFirstHalf = this.startFirstHalf.bind(this)
    this.startSecondHalf = this.startSecondHalf.bind(this)
    this.countCurrentTime = this.countCurrentTime.bind(this)
    this.pauseGame = this.pauseGame.bind(this)
    this.postComment = this.postComment.bind(this)
    this.selectTeamTag = this.selectTeamTag.bind(this)
    this.selectPlayerTag = this.selectPlayerTag.bind(this)
    this.selectTeam = this.selectTeam.bind(this)
    this.selectPlayer = this.selectPlayer.bind(this)
    this.commentChange = this.commentChange.bind(this)
    this.addQuery = this.addQuery.bind(this)
    this.agreeToQuery = this.agreeToQuery.bind(this)
    this.deleteQuery = this.deleteQuery.bind(this)
    this.saveQuery = this.saveQuery.bind(this)
    this.endGame = this.endGame.bind(this)
    this.lineOneChange = this.lineOneChange.bind(this)
    this.lineTwoChange = this.lineTwoChange.bind(this)
    this.setNewPlayerOne = this.setNewPlayerOne.bind(this)
    this.setNewPlayerTwo = this.setNewPlayerTwo.bind(this)
    this.saveLineup = this.saveLineup.bind(this)
    this.onSub = this.onSub.bind(this)
    this.addToComment = this.addToComment.bind(this)
    this.resetGame = this.resetGame.bind(this);
    this.removeTagged = this.removeTagged.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.initSystem();
  }

  componentWillUnmount() {
    this._isMounted = false;
    if(this.system){
      this.system.close()
    }
    clearInterval(this.GameInt)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
      const _that = this
      clearInterval(this.GameInt)
      FakeData.mountState("league", false)
      this.setState({
        user: { id: null },
        isLoading: true,
        game: mainStore.getGMCGame(),
        error: false,
      });

      setTimeout((() => {
        FakeData.mountState("league", true)
        _that.getGameIntial()
      }), 1000)

      return true;
    }

    return true
  }

  initSystem = () => {
    if (EventSource) {
      this.system = new EventSource(
        FakeData.fetchURL+
          "/getGame.php?auth0&event_update&userId=" +
          FakeData.getData("yoo").id +
          "&gameId=" +
          this.props.match.params.gameId
      );
      const _that = this;
      if (this.system !== null) {
        //this.system.addEventListener()
        this.system.onmessage = function(e) {
          
        };

        this.system.addEventListener(
          "open",
          function(e) {
            // Connection was opened.
            //console.log(e)
          },
          false
        );

        this.system.addEventListener(
          "game_update",
          function(e) {
            // Connection was opened.
            if (_that._isMounted) {
              const data = JSON.parse(e.data);
              if (data.error) {
                _that.setState({
                  error: true,
                  errMsg: data.msg,
                  isLoading: false
                })
              } else {
                mainStore.setGMCGame(data)
                _that.setState({
                  game: data,
                  error: false,
                  errMsg: "",
                  currentTime: data.currentTime,
                  extraTime: (data.matchExtra * 60),
                  isLoading: false,
                  isPlaying: false
                });

                if (data.isPlaying) {
                  clearInterval(_that.timerID)
                  _that.timerID = setInterval(
                    () => _that.countCurrentTime(), 1000
                  );
                }
              }
            }
          },
          false
        );

        this.system.addEventListener(
          "error",
          function(e) {
            if (e.readyState == EventSource.CLOSED) {
              // Connection was closed.
            }
          },
          false
        );
      }
    } else {
      console.warn("EventSource Streams not supoorted by browser");
      this.getGameIntial();
    }
  };

  startFirstHalf() {
    if (!this.state.game.isAdmin) {
      return
    }
    if (this.state.game.currentTime > (this.state.game.matchHalf * 60)) {
      return
    }
    const _that = this
    const dataTo = {
      isFirstHalf: true,
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/startGame.php?auth0", dataTo, {
      success: ((data) => {
        console.log(data)
        _that.setState({
          isPlaying: true
        });
        //_that.getGameIntial()
        clearInterval(_that.timerID)
        _that.timerID = setInterval(
          () => _that.countCurrentTime(), 1000
        );

        setTimeout(
          () => _that.getGame(), 2000
        );
      }),
      error: ((err) => {

      })
    })
  }

  startSecondHalf() {
    if (!this.state.game.isAdmin) {
      return
    }
    if (this.state.game.currentTime < (this.state.game.matchHalf * 60)) {
      return
    }
    const _that = this
    const dataTo = {
      isFirstHalf: false,
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/startGame.php?auth0", dataTo, {
      success: ((data) => {
        _that.setState({
          isPlaying: true
        });
        clearInterval(_that.timerID)
        _that.timerID = setInterval(
          () => _that.countCurrentTime(), 1000
        );

        setTimeout(
          () => _that.getGame(), 2000
        );
      }),
      error: ((err) => {

      })
    })
  }

  pauseGame() {
    if (!this.state.game.isAdmin) {
      return
    }
    this.setState({
      isPlaying: (this.state.isPlaying) ? false : true
    })

    if (!this.timerID) {
      return
    }

    clearInterval(this.extraTimeId)
    this.extraTimeId = setInterval(
      () => this.countExtraTime(), 1000
    );
  }

  countCurrentTime() {
    if (!this.state.game.isAdmin) {
      return
    }
    if (this.state.currentTime >= (this.state.game.duration * 60)) {
      this.setState({
        isExtraTime: true
      });
      clearInterval(this.timerID)
      clearInterval(this.extraTimeId)
      this.runETID = setInterval(
        () => this.runExtraTime(), 1000
      );
      return
    }
    this.state.currentTime++
    this.setState({
      currentTime: this.state.currentTime
    })
    this.setGameTime(this.state.currentTime)
  }

  setGameTime(time) {
    const _that = this
    const dataTo = {
      gameTime: this.state.currentTime,
      ht: this.state.game.matchHalf,
      ft: this.state.game.duration,
      extraTime: (this.state.extraTime / 60),
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/updateGameTime.php?auth0", dataTo, {
      success: ((data) => {

      }),
      error: ((err) => {

      })
    })
  }

  countExtraTime() {
    if (!this.state.game.isAdmin) {
      return
    }
    if (this.state.isPlaying) {
      return
    }

    this.state.extraTime++
    this.setState({
      extraTime: this.state.extraTime
    })
  }

  runExtraTime() {
    if (!this.state.game.isAdmin) {
      return
    }
    if (this.state.extraTime <= 0) {
      clearInterval(this.timerID)
      clearInterval(this.extraTimeId)
      clearInterval(this.runETID)
      return
    }

    this.state.extraTime--
    this.setState({
      extraTime: this.state.extraTime
    })
    this.setGameTime(this.state.currentTime)
  }

  postComment(val, cb) {
    //console.log(val);
    if (!this.state.game.isAdmin) {
      return
    } else if (!this.state.selectedTeam.id && !this.state.selectedTeamFor.id) {
      return;
    } else if ((this.state.currentTime >= (this.state.game.duration * 60)) && (this.state.extraTime <= 0)) {
      return;
    } else if (!this.state.game.isPlaying) {
      FakeData.alert("The game is not in motion yet, please start time and enjoy!")
      return;
    }
    //console.log(Math.floor(this.state.currentTime/60));
    const dataTo = {
      adminId: this.state.game.matchAdmin.id,
      leagueId: this.state.game.tournament.id,
      gameId: this.state.game.id,
      teamId: (this.state.selectedTeam.id && !this.state.selectedTeamFor.id) ? this.state.selectedTeam.id : this.state.selectedTeamFor.id,
      squadId: (this.state.selectedTeam.squadId && !this.state.selectedTeamFor.squadId) ? this.state.selectedTeam.squadId : this.state.selectedTeamFor.squadId,
      playerId: this.state.selectedPlayer.id,
      newPlayerID: this.state.secondPlayer.id,
      actionType: this.state.selectedTag,
      comment: val,
      minute: Math.floor(this.state.currentTime / 60),
      half: (this.state.currentTime > (this.state.game.matchHalf * 60)) ? "Second" : "First"
    }

    const _that = this

    FakeData.post("/createGMCComment.php?auth0", dataTo, {
      success: ((data) => {
        _that.state.game.gmcComments.unshift(data)
        _that.setState({
          game: _that.state.game,
          selectedTeam: {},
          selectedPlayer: {},
          secondPlayer: {},
          selectedTag: "",
          selectedTeamFor: "",
          value: ""
        });
        if (_that.state.selectedTag === "RC") {
          _that.state.game.teamOne.lineup.forEach((item) => {
            if (item.id === _that.state.selectedPlayer.id) {
              const pos = _that.state.game.teamOne.lineup.indexOf(item)
              _that.state.game.teamOne.lineup.splice(pos, 1)
              _that.setState({
                game: _that.state.game
              });
            }
          })

          _that.state.game.teamTwo.lineup.forEach((item) => {
            if (item.id === _that.state.selectedPlayer.id) {
              const pos = _that.state.game.teamTwo.lineup.indexOf(item)
              _that.state.game.teamTwo.lineup.splice(pos, 1)
              _that.setState({
                game: _that.state.game
              });
            }
          })
        }

        cb.call(this)
      }),
      error: ((err) => {

      })
    })
  }

  removeTagged() {
    this.setState({
      selectedTeam: {},
      selectedPlayer: {},
      secondPlayer: {},
      selectedTag: "",
      selectedTeamFor: "",
      value: ""
    });
  }

  addToComment(comment) {
    if (!this.state.game.isPlaying) {
      return;
    }
    this.state.game.gmcComments.unshift(comment)
    this.setState({
      game: this.state.game
    });
  }

  addQuery(query, id) {
    const comments = this.state.game.gmcComments
    comments.forEach((comment) => {
      if (comment.id === id) {
        comment.Queries.push(query)
        this.setState({
          game: this.state.game
        });
      }
    })
  }

  endGame() {
    if (!this.state.game.isAdmin) {
      return
    }
    const _that = this
    const dataTo = {
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/endGame.php?auth0", dataTo, {
      success: ((data) => {
        clearInterval(_that.timerID)
        clearInterval(_that.extraTimeId)
        clearInterval(_that.runETID)
      }),
      error: ((err) => {

      })
    })
  }

  resetGame() {
    if (!this.state.game.isAdmin) {
      return
    }
    const _that = this
    const dataTo = {
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/resetGame.php?auth0", dataTo, {
      success: ((data) => {
        clearInterval(_that.timerID)
        clearInterval(_that.extraTimeId)
        clearInterval(_that.runETID)
      }),
      error: ((err) => {

      })
    })
  }

  agreeToQuery(bool, field, id) {
    const comments = this.state.game.gmcComments
    //console.log(id);
    comments.forEach((comment) => {
      if (comment.id === id) {
        if (field === "teamOneConfirm") {
          comment.isTeamOneAgreed = bool
          this.setState({
            game: this.state.game
          });
        } else {
          comment.isTeamTwoAgreed = bool
          this.setState({
            game: this.state.game
          });
        }
      }
    })
  }

  deleteQuery(bool, id) {
    const comments = this.state.game.gmcComments
    //console.log(id);
    comments.forEach((comment) => {
      if (comment.id === id) {
        const index = comments.indexOf(comment)
        comments.splice(index, 1)
        this.setState({
          game: this.state.game
        });
      }
    })
  }

  saveQuery(content, id) {
    const comments = this.state.game.gmcComments
    comments.forEach((comment) => {
      if (comment.id === id) {
        comment.content = content
        this.setState({
          game: this.state.game
        });
      }
    })
  }

  commentChange(e) {
    if (!this.state.game.isAdmin) {
      return
    }
    console.log(e);
    this.setState({
      comment: e
    });
  }

  saveLineup(teamOne, teamTwo, cb) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.updateLineup(teamOne, "TeamOnePlayers")
    this.updateLineup(teamTwo, "TeamTwoPlayers")
    cb.call(this)
    return;
    const _that = this
    const dataToTwo = {
      gameId: this.state.game.id,
      teamId: this.state.game.teamTwo.id,
      squadId: this.state.game.teamTwo.squadId,
      adminId: this.state.game.matchAdmin.id,
      lineup: this.state.game.teamTwo.lineup,
      subs: this.state.game.teamTwo.subs,
      starttime: 0,
      endTime: this.state.game.duration
    }

    const dataToOne = {
      gameId: this.state.game.id,
      teamId: this.state.game.teamOne.id,
      squadId: this.state.game.teamOne.squadId,
      adminId: this.state.game.matchAdmin.id,
      lineup: this.state.game.teamOne.lineup,
      subs: this.state.game.teamOne.subs,
      starttime: 0,
      endTime: this.state.game.duration
    }

    FakeData.post("/saveGamePlayers.php?auth0", dataToTwo, {
      success: ((data) => {
        mainStore.setGMCGame(_that.state.game)
      }),
      error: ((err) => {

      })
    }, true, "", (e) => { })

    FakeData.post("/saveGamePlayers.php?auth0", dataToOne, {
      success: ((data) => {
        mainStore.setGMCGame(_that.state.game)
      }),
      error: ((err) => {

      })
    }, true, "", (e) => { })
  }

  updateLineup = (team, _key) => {
    const _that = this
    const dataTo = {
      gameId: this.state.game.id,
      teamId: team.id,
      squadId: team.squadId,
      adminId: this.state.game.matchAdmin.id,
      lineup: team.lineup,
      subs: team.subs,
      starttime: 0,
      endTime: this.state.game.duration,
      key: _key
    }

    FakeData.post("/saveGamePlayers.php?auth0", dataTo, {
      success: ((data) => {
        mainStore.setGMCGame(_that.state.game)
        return true;
      }),
      error: ((err) => {
        return false;
      })
    }, true, "", (e) => { })
  }

  getGame() {
    const _that = this;
    const _user = FakeData.getData("yoo")
    if (!_user.id || _user.id === null) {
      setTimeout(() => {
        _that.getGame();
      }, 2000)
      return;
    }
    const dataTo = {
      userId: _user.id,
      gameId: this.props.match.params.gameId
    }

    FakeData.post("/getGame.php?auth0", dataTo, {
      success: ((data) => {
        if (data.error) {
          _that.setState({
            error: true,
            errMsg: data.msg,
            isLoading: false
          })
        } else {

          mainStore.setGMCGame(data)
          _that.setState({
            game: data,
            error: false,
            errMsg: "",
            extraTime: (data.matchExtra * 60),
            isLoading: false,
            isPlaying: false
          });

          setTimeout(() => {
            _that.getGame()
          }, 1000)
        }
      }),
      error: ((err) => {
        _that.setState({
          error: true,
          errMsg: "Network problem, retrying soon!",
          isLoading: false
        })
        setTimeout(() => {
          _that.getGame()
        }, 5000)
      })
    })
  }

  getGameIntial() {
    console.log("reached")
    const _that = this
    const _user = FakeData.getData("yoo")
    if (!_user.id || _user.id === null) {
      setTimeout(() => {
        _that.getGameIntial();
      }, 1000)
      return;
    }
    const dataTo = {
      userId: _user.id,
      gameId: this.props.match.params.gameId
    }
    console.log("reached me")

    FakeData.post("/getGame.php?auth0", dataTo, {
      success: ((data) => {
        console.log("reached me too")
        if (data.error) {
          _that.setState({
            error: true,
            errMsg: data.msg,
            isLoading: false
          })
        } else {
          mainStore.setGMCGame(data)
          _that.setState({
            game: data,
            error: false,
            errMsg: "",
            currentTime: data.currentTime,
            extraTime: (data.matchExtra * 60),
            isLoading: false,
            isPlaying: false
          });
        }

        if (data.isPlaying) {
          clearInterval(_that.timerID)
          _that.timerID = setInterval(
            () => _that.countCurrentTime(), 1000
          );

          setTimeout(
            () => _that.getGame(), 2000
          );
        }
      }),
      error: ((err) => {
        setTimeout(() => {
          _that.getGameIntial();
        }, 1000)
      })
    })
  }

  onUpdatePossesion(one, two) {
    if (!this.state.game.isAdmin) {
      return
    }
    const dataTo = {
      gameId: this.state.game.id,
      pos1: one,
      pos2: two
    }

    const _that = this

    FakeData.post('/updatePossesion.php?auth0', dataTo, {
      success: ((data) => {

      }),
      error: ((err) => {

      })
    })
  }

  lineOneChange(team) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.state.game.teamOne = team
    this.setState({
      game: this.state.game
    });
  }

  lineTwoChange(team) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.state.game.teamTwo = team
    this.setState({
      game: this.state.game
    });
  }

  setNewPlayerOne(player) {
    this.state.game.teamOne.players.push(player)
    this.setState({
      game: this.state.game
    });
    this.lineOneChange(this.state.game.teamOne)
  }

  setNewPlayerTwo(player) {
    this.state.game.teamTwo.players.push(player)
    this.setState({
      game: this.state.game
    });
    this.lineTwoChange(this.state.game.teamTwo)
  }

  selectPlayer(player, team) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.setState({
      selectedPlayer: player,
      isSelectingPlayer: true,
      selectedTeamFor: team,
      isSelectingTeam: false,
      value: (this.state.selectedTeam.id && !this.state.selectedTeamFor.id) ? "[" + this.state.selectedTeam.name + "][" + this.state.selectedTag + "]" + this.state.comment : (this.state.selectedPlayer.id) ? "[" + this.state.selectedPlayer.name + "][" + this.state.selectedTag + "]" + this.state.comment : ""
    })
  }

  onSub(oldPlayer, newPlayer, teamId) {
    if (this.state.game.teamOne.id === teamId) {
      this.state.game.teamOne.lineup.forEach((player) => {
        if (player.id === oldPlayer.id) {
          player.status = "lineup-sub"
          this.state.game.teamOne.subs.push(oldPlayer)
          this.setState({
            game: this.state.game
          });
        }
      })

      this.state.game.teamOne.subs.forEach((player) => {
        if (player.id === newPlayer.id) {
          player.status = "sub-lineup"
          this.state.game.teamOne.lineup.push(newPlayer)
          this.setState({
            game: this.state.game
          });
        }
      })
    } else {
      this.state.game.teamTwo.lineup.forEach((player) => {
        if (player.id === oldPlayer.id) {
          player.status = "lineup-sub"
          this.state.game.teamTwo.subs.push(oldPlayer)
          this.setState({
            game: this.state.game
          });
        }
      })

      this.state.game.teamTwo.subs.forEach((player) => {
        if (player.id === newPlayer.id) {
          player.status = "sub-lineup"
          this.state.game.teamTwo.lineup.push(newPlayer)
          this.setState({
            game: this.state.game
          });
        }
      })
    }
  }

  selectTeam(team) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.setState({
      selectedTeam: team,
      selectedTeamFor: {},
      isSelectingPlayer: false,
      isSelectingTeam: true,
      value: (this.state.selectedTeam.id && !this.state.selectedTeamFor.id) ? "[" + this.state.selectedTeam.name + "][" + this.state.selectedTag + "]" + this.state.comment : (this.state.selectedPlayer.id) ? "[" + this.state.selectedPlayer.name + "][" + this.state.selectedTag + "]" + this.state.comment : ""
    })
  }

  selectTeamTag(tag) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.setState({
      selectedTag: tag,
      selectedPlayer: {},
      secondPlayer: {},
      isSelectingPlayer: false,
      isSelectingTeam: true,
      value: (this.state.selectedTeam.id && !this.state.selectedTeamFor.id) ? "[" + this.state.selectedTeam.name + "][" + tag + "]" + this.state.comment : (this.state.selectedPlayer.id) ? "[" + this.state.selectedPlayer.name + "][" + tag + "]" + this.state.comment : ""
    });
  }

  selectPlayerTag(tag, player) {
    if (!this.state.game.isAdmin) {
      return
    }
    this.setState({
      selectedTag: tag,
      selectedTeam: {},
      secondPlayer: player,
      isSelectingPlayer: true,
      isSelectingTeam: false,
      value: (this.state.selectedTeam.id && !this.state.selectedTeamFor.id) ? "[" + this.state.selectedTeam.name + "][" + tag + "]" + this.state.comment : (this.state.selectedPlayer.id) ? "[" + this.state.selectedPlayer.name + "][" + tag + "]" + this.state.comment : ""
    });
  }

  render() {
    const tags = GMCTags[this.state.game.sport]
    if (this.state.isLoading) {
      return (
        <BannerShimmer />
      );
    }

    if(this.state.error){
      return(
        <Redirect to={{
          pathname: "/no-game-found"
        }}/>
      )
    }

    return (
      <div className="gmc_container sp-gmc-flex-width" style={{ padding: "0px 0px 50px 0px" }}>
        <Helmet>
          <title>{this.state.game.teamOne.name} vs {this.state.game.teamTwo.name} Console - Supotsu</title>
        </Helmet>
        <div className="gmc-core">
          {(!this.state.isLoading && !this.state.error) &&
            <h1>{this.state.game.teamOne.name} vs {this.state.game.teamTwo.name}</h1>
          }
          {(!this.state.isLoading && !this.state.error) &&
            <div className="gmc-core-board">
              <GMCCoreHeader onSaveLineUp={this.saveLineup} addPlayerTeamOne={this.setNewPlayerOne} addPlayerTeamTwo={this.setNewPlayerTwo} onLineupChangeOne={this.lineOneChange} onLineupChangeTwo={this.lineTwoChange} onEnd={this.endGame} onReset={this.resetGame} onStartFirstHalf={this.startFirstHalf} onStartSecondHalf={this.startSecondHalf} onPause={this.pauseGame} game={this.state.game} />
              <div className="gmc-core-body">
                <GMCCoreTeam currentTime={this.state.currentTime} onPostComment={this.addToComment} game={this.state.game} onSub={this.onSub} onPlayerSelect={this.selectPlayer} selectionState={this.state.selectionState} team={this.state.game.teamOne} />
                <GMCCoreFeed onUpdatePossesion={(one, two) => this.onUpdatePossesion(one, two)} onDelete={this.deleteQuery} onSave={this.saveQuery} onAgree={this.agreeToQuery} onAddQuery={this.addQuery} Comments={this.state.game.gmcComments} onCommentChange={this.commentChange} value={this.state.value} onTeamSelect={this.selectTeam} onTeamTagSelect={this.selectTeamTag} onPlayerTagSelect={this.selectPlayerTag} selectionState={this.state.selectionState} teamTags={tags.team} playerTags={tags.player} onPost={this.postComment} game={this.state.game} currentTime={this.state.currentTime} extraTime={this.state.extraTime} removeTagged={this.removeTagged} />
                <GMCCoreTeam currentTime={this.state.currentTime} onPostComment={this.addToComment} game={this.state.game} onSub={this.onSub} onPlayerSelect={this.selectPlayer} selectionState={this.state.selectionState} team={this.state.game.teamTwo} />
              </div>
            </div>
          }

          {(this.state.error && (this.state.errMsg === "Not logged")) &&
            <div className="gmc-core-error-login">
              Loggin please
              </div>
          }

          {(this.state.error && (this.state.errMsg === "Not an Admin/Captain")) &&
            <div className="gmc-core-error-login">
              You are not the GMC admin
              </div>
          }

          {(this.state.error && (this.state.errMsg === "No Game")) &&
            <div className="gmc-core-error-login">
              {"Game or Page doesn't exist"}
            </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GMC.js